import {
    REVIEWS_TOUR_LANDING_API_START,
    REVIEWS_TOUR_LANDING_API_SUCCESS,
    REVIEWS_TOUR_LANDING_API_ERROR
} from "../Constant/TourReviewsConstant"

const initialState = {
    loading: false,
    reviewsTourLandingData: [],
}

export default function ReviewsTourLandingReducer(
    state = { ...initialState},
    action
) {
    switch (action.type) {
        case REVIEWS_TOUR_LANDING_API_START:
           return {
               ...state,
               loading: true,
           };
           case REVIEWS_TOUR_LANDING_API_SUCCESS:
           return {
               ...state,
               reviewsTourLandingData: action.payload,
               loading: false,
           };
           case REVIEWS_TOUR_LANDING_API_ERROR:
               return {
                   ...state,
                   loading: false,
                   message: action.error.message,
               };
               default:
                   return state;
    }
}